import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import noop from 'lodash/noop';

import styles from './DepartmentsList.module.scss';

@injectIntl
export default class DepartmentsListWithoutMap extends Component {
  static propTypes = {
    onClick: PropTypes.func,
    polishOffices: PropTypes.array,
    abroadOffices: PropTypes.array
  };

  static defaultProps = {
    onClick: noop,
    polishOffices: [],
    abroadOffices: []
  };

  render() {
    const { polishOffices, abroadOffices } = this.props;
    abroadOffices.sort((a, b) => {
      return a.country.name.localeCompare(b.country.name);
    });

    const RenderOffice = props => {
      const { className = '', office = {}, showCountryName } = props;
      const [adressLine1, adressLine2, adressLine3] = office.address.split(
        ' / '
      );

      return (
        <div className={className}>
          {showCountryName && (
            <h2
              className={`${styles.CountryHeader} ${styles.CountryHeaderPol}`}
            >
              {office.country.name}
            </h2>
          )}
          <div className={styles.CityContainer}>
            <h4 className={styles.CityHeader}>{office.location}</h4>
            <div className={styles.AdressBox}>
              <p>{adressLine1}</p>
              <p>{adressLine2}</p>
              {adressLine3 && <p>{adressLine3}</p>}
              <p>{office.phoneNumber}</p>
            </div>
            <a className={styles.Email} href={`mailto:${office.email}`}>
              {office.email}
            </a>
          </div>
        </div>
      );
    };

    return (
      <div className={styles.CountriesWrapper}>
        <div className={styles.DepartmentsWrapper}>
          {polishOffices.map((office, index) => (
            <RenderOffice
              key={office.id}
              office={office}
              className={styles.CountryPolandWrapper}
              showCountryName={index === 0}
            />
          ))}
        </div>
        <div className={styles.DepartmentsWrapper}>
          {abroadOffices.map(office => (
            <RenderOffice
              key={office.id}
              office={office}
              className={styles.CountryWrapper}
              showCountryName={true}
            />
          ))}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/DepartmentsList/DepartmentsListWithoutMap.js